import React from "react";
import { Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";

import Checkbox from "../../../../components/common/checkbox/Checkbox";
import Button from "../../../../components/common/button/Button";
import { required } from "../../../../utils/forms/validators";

import close from "../../../../assets/images/close-icon.svg";

import styles from "./DeleteMemberModal.scss";

const DeleteMemberModal = props => {
  const {
    invalid,
    submitting,
    pristine,
    deleteMember,
    onHide,
    handleSubmit
  } = props;

  return (
    <div className={styles.deleteMemberModal}>
      <div className={styles.modalContainer}>
        <img src={close} className={styles.closebutton} onClick={onHide} />
        <div className={styles.container}>
          <div className={styles.content}>
            <Form onSubmit={handleSubmit(deleteMember)}>
              <div className={styles.form}>
                <h2 className={styles.title}>Delete User</h2>

                <div className={styles.dividerLine} />

                <div className={styles.subtitle}>
                  <p>
                    Are you sure you want to delete this user? Doing so will:
                  </p>
                  <ul>
                    <li>Remove the user from our system</li>
                    <li>Delete their project history</li>
                  </ul>
                  <br />
                  <p>If so, check below to continue:</p>
                </div>

                <label className={styles.checkbox}>
                  <Field
                    name="valid"
                    component={Checkbox}
                    validate={[required]}
                  />
                  <span class={styles.checkboxText}>Yeah, yeah, I get it.</span>
                </label>

                <br />

                <Button
                  isDisabled={invalid || submitting || pristine}
                  isPrimary
                  type="submit"
                  size="large"
                  label="Delete User Account"
                />

                <Link to="#" onClick={onHide}>
                  Cancel and go back
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default reduxForm({
  form: "DeleteMemberModal"
})(DeleteMemberModal);



// WEBPACK FOOTER //
// ./src/routes/common/header/deleteMemberModal/DeleteMemberModal.js